import React, { ReactNode } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import './base-content-box.css'

/**
 * Props to use when initializing a `ContentBox` component.
 */
export interface BaseContentBoxProps {
  /**
   * a node to be rendered in the special component.
   */
  children?: ReactNode
  /**
   * The default size value for the box is 388 If you want a different size pass that value here
   */
  customWidth?: number | string
  /**
   * For extra styling add you own className 
   */
  className?: string
  /**
   * Pass a string that will be used as a title placed at the top of the box
   */
  title?: ReactNode
  /**
   * If passing a value of true the size of the box will adjust automatically for medium and small devices
   */
  autoSizeBox?: boolean
}

/**
 * Content box for PTCS apps.
 */
export function BaseContentBox({ children, customWidth, className, autoSizeBox, title }: BaseContentBoxProps) {
  const theme = useTheme()
  const mediumScreen = useMediaQuery(theme.breakpoints.down('md'))
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  let contentBoxWidth: number | string

  if (customWidth) {
    contentBoxWidth = customWidth
  } else {
    contentBoxWidth = 388
  }

  if (mediumScreen && autoSizeBox) {
    contentBoxWidth = 450
  }

  if (smallScreen && autoSizeBox) {
    contentBoxWidth = 'inherit'
  }

  if (title) {
    return (
      <div className={className ? `base-container base-container-title ${className}` : 'base-container base-container-title'} style={{ width: contentBoxWidth }}>
        <div className='base-container-title-title'>{title}</div>
        <hr className='base-container-title-hr' />
        <div className='base-container-title-content'>
          {children}
        </div>
      </div>
    )
  } else {
    return (
      <div className={className ? `base-container ${className}` : 'base-container'} style={{ width: contentBoxWidth }}>
        {children}
      </div>
    )
  }
}
